import { $ } from "../third-party-imports";

export function mobileUpdatePostalCodeOnHeader()
{
    if (localStorage.getItem('searchTerm') !== undefined)
    {
        $(".navWrapper .propertForm").find('input').val(localStorage.getItem('searchTerm'));
    }
}
